import { Offer } from '../../../shared/types';
import { isNonEmpty } from '../../../utils/string-utils';
import { getCurrency } from '../../../shared/product-page-placement/currency';
import { formatMoney } from '../../../dissolve/utils';
import { convertPresentmentCurrency } from '../../../dissolve/helpers';

export function getBadgeData(offer: Offer, id?: number) {
  let badge_label = offer.badge_label;
  let badge_background_color = offer.badge_background_color;
  let badge_text_color = offer.badge_text_color;
  const hasBadge =
    isNonEmpty(badge_label) &&
    isNonEmpty(badge_background_color) &&
    isNonEmpty(badge_text_color);
  if (!hasBadge && offer.items?.length > 0 && offer.is_product) {
    const productId = offer.is_product ? id : undefined;
    const relevantItem = offer.items.find(
      (item) => offer.is_product && item.item_id === productId,
    );
    return {
      label: relevantItem?.item_badge_label,
      bgColor: relevantItem?.item_badge_background_color,
      textColor: relevantItem?.item_badge_text_color,
    };
  }

  return {
    label: badge_label,
    bgColor: badge_background_color,
    textColor: badge_text_color,
  };
}

function formatAmountForBadge(offer: Offer): string {
  const discount = convertPresentmentCurrency(
    Number(offer.amount),
    offer.amount_type,
  );

  if (offer.amount_type === 'percentage') {
    // If the discount is effectively zero
    if (Math.abs(discount) < 0.01) {
      return '0%';
    }

    // If discount has no decimals (e.g. 7.00 → 7%), return integer
    if (Number.isInteger(discount)) {
      return `${discount}%`;
    }

    // Else, format with 2 decimals
    return `${(Math.round(discount * 100) / 100).toFixed(2)}%`;
  }

  try {
    return formatMoney(discount, getCurrency().currency);
  } catch {
    return `${discount.toFixed(2)} ${getCurrency().currency}`;
  }
}

export function replaceAmountVariable(label: string, offer: Offer): string {
  if (!label.includes('{{amount}}')) {
    return label;
  }
  const amount = Number(offer.amount);

  // Return with empty string if amount is invalid
  if (!amount) {
    return label.replaceAll('{{amount}}', '');
  }

  const formattedAmount = formatAmountForBadge(offer);

  return label
    .replace('{{amount}}', formattedAmount)
    .replaceAll('{{amount}}', ''); //get rid of any remaining placeholders
}
